/* Meten op de collectiepagina — WoodWideCities
   ============================================

   Alles gaat naar window.dataLayer, zodat GTM de events oppakt en Consent Mode
   zijn werk kan doen. Nooit rechtstreeks naar gtag: dan omzeil je de
   toestemmingslaag en ontstaat er een systematisch gat in de cijfers.

   WAAROM EIGEN EVENTNAMEN
   Er staat al een `view_item_list` in de dataLayer, gevuld door een andere
   bron: één keer per pagina, met alle 55 producten, onder item_list_id
   "catalog". Daaraan kun je niet zien welke stad, welke productsoort of welke
   positie — precies de dingen waar we op willen sturen. Die bron kan ik hier
   niet uitzetten, dus onze events dragen een eigen naam. Zodra de oude tag in
   GTM uit staat, is dit één regel: zet PREFIX op '' en de namen worden de
   standaard GA4-namen.

   ELK EVENT BEANTWOORDT ÉÉN TERUGKERENDE VRAAG.
   Wat dat niet doet, meten we niet — zie onderaan. */
(function () {
  'use strict';

  var PREFIX = 'wwc_';          // '' zodra de oude view_item_list-tag uit staat
  var DREMPEL = 0.5;            // hoeveel van een kaart in beeld telt als gezien
  var VERBLIJF = 1000;          // ms dat hij in beeld moet blijven

  function dl() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function viewer() {
    return document.querySelector('.wwc-collection-viewer');
  }

  /* Gedeelde context op élk event.

     `collection_kind` is de sleutel voor de lange staart: losse stadpagina's
     halen 150-183 sessies per maand, en pas geaggregeerd over 712 pagina's
     ontstaan er aantallen waar je een besluit op durft te nemen.

     `visible_cards` is de noemer. Zonder dat getal is geen enkele meting te
     vergelijken tussen een pagina met 16 kaarten en een met 33. */
  function context() {
    var v = viewer();
    return {
      collection_handle: (v && v.getAttribute('data-wwc-handle')) || '',
      collection_kind: (v && v.getAttribute('data-wwc-kind')) || 'overig',
      visible_cards: kaarten().length
    };
  }

  function stuur(naam, gegevens) {
    var payload = { event: PREFIX + naam };
    var c = context();
    for (var k in c) payload[k] = c[k];
    for (var g in gegevens) payload[g] = gegevens[g];
    dl().push(payload);
  }

  function kaarten() {
    return Array.prototype.filter.call(
      document.querySelectorAll('#CollectionAjaxContent .grid-product'),
      function (k) { return k.offsetParent !== null; });
  }

  function beschrijf(kaart, index) {
    var titel = kaart.querySelector('.grid-product__title');
    var actief = kaart.querySelector('.wwc-swatch[aria-pressed="true"]');
    return {
      index: index + 1,
      item_id: kaart.getAttribute('data-product-handle') || '',
      item_name: titel ? titel.textContent.trim() : '',
      wwc_type: kaart.getAttribute('data-wwc-type') || '',
      wwc_material_shown: actief ? (actief.getAttribute('aria-label') || '') : '',
      price: (parseInt(kaart.getAttribute('data-wwc-low') ||
                       kaart.getAttribute('data-wwc-price') || '0', 10) / 100) || undefined
    };
  }

  /* ── 1. Welke kaarten worden werkelijk gezien, en op welke positie? ────────
     Beslist de standaardvolgorde van het raster. Nu de grootste blinde vlek:
     de vlaggenschip-skyline staat op positie 7 terwijl de gemiddelde bezoeker
     tot ongeveer positie 8 komt.

     Gebundeld per uitzendbeurt in plaats van per kaart: vijf losse events voor
     één rij maakt het rapport onleesbaar en kost onnodig quota. */
  var gezien = {};
  var wachtrij = [];
  var wachtTimer = null;

  function meldGezien() {
    if (!wachtrij.length) return;
    var items = wachtrij.slice();
    wachtrij.length = 0;
    var v = viewer();
    stuur('items_view', {
      item_list_id: (v && v.getAttribute('data-wwc-handle')) || 'collection',
      item_list_name: document.title.split('|')[0].trim(),
      items: items
    });
  }

  /* Zichtbaarheid: één waarnemer, en een herhaalde controle.

     Eerdere opzet maakte bij elke aanroep een nieuwe IntersectionObserver en
     hing die aan de kaarten die op dát moment zichtbaar waren. Gemeten: nul
     items_view-events op een pagina met negentien kaarten waarvan de eerste
     aantoonbaar in beeld stond. De oorzaak is timing - het raster wordt door
     de groepsmodule herschikt, verborgen en weer getoond, en wie precies op
     het verkeerde moment aanhaakt ziet niets.

     Daarom nu: één waarnemer die blijft leven, plus een lichte hercontrole die
     nieuwe kaarten aanmeldt. Die controle stopt zodra alles is gezien of na
     twintig seconden, dus hij kost niets op een pagina waar niemand scrollt. */
  var waarnemer = null;
  var aangemeld = null;
  var dwellTimers = null;

  function maakWaarnemer() {
    if (waarnemer || !('IntersectionObserver' in window)) return;
    aangemeld = new WeakSet();
    dwellTimers = new WeakMap();

    waarnemer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var kaart = e.target;
        var handle = kaart.getAttribute('data-product-handle') || '';
        if (gezien[handle]) return;

        if (e.isIntersecting && e.intersectionRatio >= DREMPEL) {
          // Pas tellen als hij ook even blijft staan. Wie in één veeg langs
          // twintig kaarten schiet, heeft ze niet gezien.
          dwellTimers.set(kaart, setTimeout(function () {
            if (gezien[handle]) return;
            gezien[handle] = true;
            wachtrij.push(beschrijf(kaart, kaarten().indexOf(kaart)));
            clearTimeout(wachtTimer);
            wachtTimer = setTimeout(meldGezien, 300);
            waarnemer.unobserve(kaart);
          }, VERBLIJF));
        } else {
          clearTimeout(dwellTimers.get(kaart));
        }
      });
    }, { threshold: [DREMPEL] });
  }

  function meldKaartenAan() {
    maakWaarnemer();
    if (!waarnemer) return 0;
    var nieuw = 0;
    kaarten().forEach(function (k) {
      if (aangemeld.has(k)) return;
      aangemeld.add(k);
      waarnemer.observe(k);
      nieuw++;
    });
    return nieuw;
  }

  function volgZichtbaarheid() {
    meldKaartenAan();

    var rondes = 0;
    var tik = setInterval(function () {
      rondes++;
      meldKaartenAan();
      var open = kaarten().filter(function (k) {
        return !gezien[k.getAttribute('data-product-handle') || ''];
      }).length;
      if (open === 0 || rondes > 20) clearInterval(tik);
    }, 1000);
  }

  function volgRasterWijzigingen() {
    var grid = document.querySelector('#CollectionAjaxContent, .product-grid-container, [data-wwc-grid-shell]');
    if (!grid || !('MutationObserver' in window)) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(meldKaartenAan, 250);
    }).observe(grid, { childList: true, subtree: true });
  }

  /* ── 2. Welke productsoorten en posities verdienen hun plek? ───────────────
     Samen met event 1 geeft dit een klikratio per positie - de enige harde
     onderbouwing om kaarten te herordenen of te schrappen. */
  function volgKliks() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // Een bolletje is geen productkeuze; die heeft zijn eigen event.
      if (t.closest('.wwc-swatch')) return;

      var kaart = t.closest('#CollectionAjaxContent .grid-product');
      if (kaart) {
        var lijst = kaarten();
        stuur('select_item', beschrijf(kaart, lijst.indexOf(kaart)));
      }
    }, true);
  }

  /* ── 3. Moet de productsoorten-rij blijven, en in welke volgorde? ──────────
     Hij staat bóven de vouw op 712 pagina's en kost daar de duurste ruimte
     van de pagina. Wordt hij niet gebruikt, dan is dat de eerste plek om op
     te ruimen. */
  function volgTyperij() {
    document.addEventListener('click', function (e) {
      var knop = e.target && e.target.closest ? e.target.closest('[data-wwc-product-filter]') : null;
      if (!knop) return;
      var spoor = knop.parentNode;
      var alle = spoor ? Array.prototype.slice.call(spoor.children) : [];
      var label = knop.querySelector('span:not(.wwc-visual-type-card__image)');
      stuur('type_select', {
        type_name: label ? label.textContent.trim() : (knop.getAttribute('data-wwc-product-filter') || ''),
        position: alle.indexOf(knop) + 1,
        source: knop.closest('.wwc-slim-bar') ? 'slimme-balk' : 'slider'
      });
    }, true);
  }

  /* ── 4. Verkennen mensen materialen op het raster, en waar landen ze? ──────
     Beslist twee dingen tegelijk: is Eiken de juiste standaard, en kan de
     materiaalnaam uit de feitenregel weg omdat de bolletjes het werk al doen. */
  function volgMaterialen() {
    document.addEventListener('click', function (e) {
      var bol = e.target && e.target.closest ? e.target.closest('.wwc-swatch') : null;
      if (!bol) return;
      var kaart = bol.closest('#CollectionAjaxContent .grid-product');
      if (!kaart) return;
      var vorige = kaart.querySelector('.wwc-swatch[aria-pressed="true"]');
      stuur('material_select', {
        item_id: kaart.getAttribute('data-product-handle') || '',
        material_from: vorige ? (vorige.getAttribute('aria-label') || '') : '',
        material_to: bol.getAttribute('aria-label') || ''
      });
    }, true);
  }

  /* ── 5. Welke facetten verdienen hun plaats, en wordt de slimme balk gebruikt?
     `source` is hier het hele punt: de balk, de lade en de slider zijn drie
     ingangen naar dezelfde filters. Scoort de balk niet, dan kan hij weg.

     Bewust gemeten bij het RESULTAAT en niet bij het openen van de lade: mensen
     openen die uit nieuwsgierigheid, en alleen een toegepast filter verandert
     een beslissing. */
  function volgFilters() {
    try { sessionStorage.setItem('wwc:filterbron', ''); } catch (e) {}

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var bron = null;
      if (e.target.closest('.wwc-slim-bar')) bron = 'slimme-balk';
      else if (e.target.closest('[data-wwc-filter-drawer]')) bron = 'lade';
      else if (e.target.closest('.wwc-visual-type-filter')) bron = 'slider';
      if (bron) { try { sessionStorage.setItem('wwc:filterbron', bron); } catch (er) {} }
    }, true);

    // Bij het laden: wat staat er aan?
    var params = new URLSearchParams(window.location.search);
    var bron = 'onbekend';
    try { bron = sessionStorage.getItem('wwc:filterbron') || 'direct'; } catch (e) {}

    var aantal = kaarten().length;
    params.forEach(function (waarde, sleutel) {
      if (sleutel.indexOf('filter.') !== 0) return;
      stuur('filter_apply', {
        filter_group: sleutel.replace(/^filter\.[pv]\./, '').replace(/^m\./, ''),
        filter_value: waarde,
        results_count: aantal,
        source: bron
      });
    });
  }

  /* ── 6. Wordt er gesorteerd, en waarop? ───────────────────────────────────
     Bepaalt of het repareren van de prijssortering prioriteit had, en of de
     lijst met sorteeropties verder terug kan. */
  function volgSortering() {
    document.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('[data-wwc-sort]') : null;
      if (!sel) return;
      stuur('sort_change', { sort_value: sel.value, results_count: kaarten().length });
    }, true);
  }

  /* ── 7. Loopt de productsoorten-slider dood? ──────────────────────────────
     Dit blok verschijnt alleen ná een typefilter. Veel kliks betekent dat de
     slider te dunne resultaten oplevert - in Utrecht levert "Klok" twee
     kaarten op. Dat is een direct signaal om typegroepen samen te voegen of
     te verbergen bij te weinig resultaten. */
  function volgOntdek() {
    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('.wwc-alles-ontdekken__knop') : null;
      if (!link) return;
      var params = new URLSearchParams(window.location.search);
      stuur('see_all', {
        active_type: params.get('filter.p.product_type') || '',
        results_count: kaarten().length
      });
    }, true);
  }

  /* ── 8. Waar sterft de pagina af? ─────────────────────────────────────────
     De noemer waartegen alles hierboven wordt afgezet. Uit Clarity komt 24-26%
     scrolldiepte; dit maakt zichtbaar of onze ingrepen daar iets aan doen. */
  function volgScrolldiepte() {
    var drempels = [25, 50, 75, 100];
    var gedaan = {};
    var bezig = false;

    function meet() {
      bezig = false;
      var hoogte = document.documentElement.scrollHeight - window.innerHeight;
      if (hoogte <= 0) return;
      var pct = Math.round(((window.pageYOffset || 0) / hoogte) * 100);
      drempels.forEach(function (d) {
        if (pct >= d && !gedaan[d]) {
          gedaan[d] = true;
          stuur('collection_scroll', { percent: d });
        }
      });
    }

    window.addEventListener('scroll', function () {
      if (bezig) return;
      bezig = true;
      window.requestAnimationFrame ? requestAnimationFrame(meet) : setTimeout(meet, 120);
    }, { passive: true });
  }

  /* WAT WE BEWUST NIET METEN
     - de lijst/raster-schakelaar: daar hangt geen terugkerende beslissing aan;
       dat is een eenmalige vraag, beantwoord hem met een Clarity smart event.
     - het verschijnen van de slimme balk: verschijnen is geen gedrag. Gebruik
       telt, en dat zit in filter_apply via `source`.
     - het openen van de filterlade: zonder toegepast filter is dat ruis.
     - quick view: er is al select_item en op de productpagina view_item. Een
       derde tussenstap maakt de trechter onleesbaar.
     - hover en tijd-op-kaart: dat is Clarity-terrein. GA4 hoort de
       beslissingsmomenten te bevatten, niet de aandacht. */

  function start() {
    if (!viewer()) return;
    if (window.__wwcMetenAan) return;
    window.__wwcMetenAan = true;

    volgZichtbaarheid();
    volgRasterWijzigingen();
    // Nog één keer als alles binnen is: bij het opbouwen kan de grid nog
    // verborgen zijn geweest.
    window.addEventListener('load', function () { setTimeout(volgZichtbaarheid, 400); });
    volgKliks();
    volgTyperij();
    volgMaterialen();
    volgFilters();
    volgSortering();
    volgOntdek();
    volgScrolldiepte();

    // Handvat om in de console te controleren of het meten leeft.
    window.__wwcMeten = {
      hercontroleer: meldKaartenAan,
      gezien: function () { return Object.keys(gezien).length; }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
